import React from 'react'
import { t } from '../../jsCore/providers/i18nProvider/i18nProvider'
import { Image } from '../image/image'
import { buildLinkUrl, reportAnalytics, imageProps, hasPosts } from './utils'

export class recommendedPostsCardsContainer extends React.Component {
  render = () => {
    if (!hasPosts(this.props.posts)) {
      return null
    }
    return (
      <div
        className="recommeneded_posts_cards__container"
        data-viewability="in-article recommendations-cards"
      >
        <div className="recommeneded_posts_cards__title">
          {t('post_page.similar_articles').toUpperCase()}
        </div>
        <div className="recommeneded_posts_cards__divider" />
        {this.props.posts.map((post, index) => {
          return relatedArticleView(post, index)
        })}
      </div>
    )
  }
}

function relatedArticleView(post, index) {
  return (
    <a
      className="recommended_post_img_and_title_wrraper"
      href={buildLinkUrl(post.url, index, 'cards')}
      target="_self"
      onClick={() => reportAnalytics('cards', index)}
      key={index}
    >
      <Image {...imageProps(post.image_url, 'recommended_post__container__img')} />
      <div className="recommended_post__container__title">
        {post.title}
        <div className="recommended_post__container__auther">
          By {post.author_name}
        </div>
      </div>
    </a>
  )
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/components/recommendedPosts/recommendedPostsCardsContainer.js